// extracted by mini-css-extract-plugin
export var cardIcon = "_66-5";
export var cardIconUnframed = "_66-9";
export var checkboxCard = "_66-0";
export var checkboxCardSelected = "_66-4";
export var disabled = "_66-2";
export var interactive = "_66-1";
export var outerBorder = "_66-3";
export var spacerMedium = "_66-8";
export var spacerSmall = "_66-7";
export var spacerXsmall = "_66-6";